/** possible messageTypes for web socket
 * @type {{messageTypes: {SYSTEM: string, TABLE: string, CAROUSEL_BROWSE: string, IMAGE: string, CHIPS: string, CAROUSEL_SELECT: string, TEXT: string, FILE: string, AUDIO: string, LIST: string, FILE_LIMITS: string, CARD: string}}}
 */
module.exports = {
  messageTypes: {
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    CHIPS: 'CHIPS',
    SYSTEM: 'SYSTEM',
    AUDIO: 'AUDIO',
    CARD: 'CARD',
    LIST: 'LIST',
    TABLE: 'TABLE',
    CAROUSEL_BROWSE: 'CAROUSEL_BROWSE',
    CAROUSEL_SELECT: 'CAROUSEL_SELECT',
    FILE: 'FILE',
    FILE_LIMITS: 'FILE_LIMITS',
    MID_CHAT_FORM: 'DATA_COLLECTION_FORM',
    LINK: 'URL'
  },
  chatbotSelectTopicTrackingIds: [
    '1000', '1001', '1025', '1041', '1043', '3000', '3001', '3002', '3003', '3004', '3005',
    '3007', '3008', '3009', '3010', '3062', '3061', '3068'
  ],
  uiToggleConfigs: {
    isAnalyticsEnabled: true,
    isSearchConnexEnabled: true,
    enableLoggedInUser: true
  }
}
